import "urlpattern-polyfill";
import "./services/theme.ts";
import "./components/views/app-view.ts";
import "./live-reload.ts";
import { type AppStore, appStore } from "./components/app-store.ts";
import * as Json from "../util/json.ts";

// Expose app store and helpers on global object
declare global {
  var appStore: AppStore;
  var serializeAppState: () => string;
}

globalThis.appStore = appStore;

/** Dumps the current app state as a JSON string. Useful when troubleshooting. */
globalThis.serializeAppState = () => Json.serialize(appStore.get());
